export interface PandimLine {
  id: string;
  name: string;
  category: string;
  description: string;
  photos: string[];
  url: string;
}

export const pandimLines: PandimLine[] = [
  {
    id: 'linha-pe40',
    name: 'Linha PE40',
    category: 'Mesas Executivas',
    description: 'Linha executiva com tampos de 40mm de espessura, estrutura robusta e acabamento refinado. Disponível em configurações retas, em L e com gaveteiro integrado. Ideal para diretores e gerentes.',
    photos: [
      'https://www.pandin.com.br/wp-content/uploads/2025/04/01-Escritorio-Duplo-PE40-Grafito-Salvia-1024x768.jpg',
      'https://www.pandin.com.br/wp-content/uploads/2025/04/1-6.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/2-1.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/1-1.png',
    ],
    url: 'https://www.pandin.com.br/linha-pe40/',
  },
  {
    id: 'linha-p25',
    name: 'Linha P25',
    category: 'Mesas Corporativas',
    description: 'Linha corporativa com tampos de 25mm, design moderno e versátil. Perfeita para ambientes de trabalho colaborativos, salas de reunião e escritórios de médio porte.',
    photos: [
      'https://www.pandin.com.br/wp-content/uploads/2025/04/00-Sala-Corporativa-Linha-P25-Corporativa-Samba-grafito-1024x768.jpg',
      'https://www.pandin.com.br/wp-content/uploads/2025/04/2-1.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/3.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/4.png',
    ],
    url: 'https://www.pandin.com.br/linha-p25/',
  },
  {
    id: 'linha-maxxi',
    name: 'Linha Maxxi',
    category: 'Mesas Operacionais',
    description: 'Linha operacional focada em versatilidade e custo-benefício, com tampos de 15mm. Ideal para call centers, plataformas de trabalho e ambientes de alta densidade de pessoas.',
    photos: [
      'https://www.pandin.com.br/wp-content/uploads/2025/04/ambiente-maxxi-walnut-preto-1024x768.jpg',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/5.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/6.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/04/3-1.png',
    ],
    url: 'https://www.pandin.com.br/linha-maxxi-pandin/',
  },
  {
    id: 'linha-corporativa',
    name: 'Linha Corporativa',
    category: 'Plataformas Coletivas',
    description: 'Soluções para ambientes de trabalho compartilhados e coworking. Mesas plataforma para 2, 4 ou mais pessoas, com calhas para fiação e caixas de tomada integradas.',
    photos: [
      'https://www.pandin.com.br/wp-content/uploads/2025/04/00-Sala-Coworking-Linha-Corporativa-Plataformas-4-lugares-2-1024x768.jpg',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/11.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/04/01-Escritorio-Duplo-PE40-Grafito-Salvia-1024x768.jpg',
      'https://www.pandin.com.br/wp-content/uploads/2025/04/00-Sala-Corporativa-Linha-P25-Corporativa-Samba-grafito-1024x768.jpg',
    ],
    url: 'https://www.pandin.com.br/linha-corporativa/',
  },
  {
    id: 'linha-p15',
    name: 'Linha P15',
    category: 'Design Slim',
    description: 'Design leve e visual slim. A Linha P15 traz modernidade e elegância para escritórios contemporâneos, com estrutura metálica fina e tampos em acabamentos exclusivos.',
    photos: [
      'https://www.pandin.com.br/wp-content/uploads/2025/11/11.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/1-1.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/04/ambiente-maxxi-walnut-preto-1024x768.jpg',
      'https://www.pandin.com.br/wp-content/uploads/2025/04/2-1.png',
    ],
    url: 'https://www.pandin.com.br/linha-p15/',
  },
  {
    id: 'linha-aco',
    name: 'Linha Aço',
    category: 'Móveis de Aço',
    description: 'Armários, arquivos, roupeiros e estantes de aço com pintura eletrostática e tratamento antiferrugem. Resistência e durabilidade para ambientes corporativos e industriais.',
    photos: [
      'https://www.pandin.com.br/wp-content/uploads/2025/04/Vestiario-Roupeiros-Cinza_Branco-1024x768.jpg',
      'https://www.pandin.com.br/wp-content/uploads/2025/04/3-1.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/5.png',
      'https://www.pandin.com.br/wp-content/uploads/2025/11/6.png',
    ],
    url: 'https://www.pandin.com.br/linha-aco-3-2/',
  },
];
